import { useState, useEffect } from 'react';
import { BREAKPOINTS } from '../constants/index';

export const useMediaQuery = (breakpoint) => {
  const query = `(max-width: ${BREAKPOINTS[breakpoint]})`;
  const [matches, setMatches] = useState(null);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);

    setMatches(mediaQueryList.matches);

    const handleChange = (event) => setMatches(event.matches);

    mediaQueryList.addEventListener('change', handleChange);

    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
};
